import { render, staticRenderFns } from "./_dividends.vue?vue&type=template&id=50ec8f2c&scoped=true&"
import script from "./_dividends.vue?vue&type=script&lang=js&"
export * from "./_dividends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ec8f2c",
  null
  
)

export default component.exports